import React, { type ComponentProps } from 'react';
import { Svg } from './src/Svg/Svg';

type IconProps = {
  size?: number;
} & ComponentProps<'svg'>;

/* FILL ICONS */

export function Pause({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Pause">
      <path
        d="M20.25 4.5V19.5C20.25 19.8978 20.092 20.2794 19.8107 20.5607C19.5294 20.842 19.1478 21 18.75 21H15C14.6022 21 14.2206 20.842 13.9393 20.5607C13.658 20.2794 13.5 19.8978 13.5 19.5V4.5C13.5 4.10218 13.658 3.72064 13.9393 3.43934C14.2206 3.15804 14.6022 3 15 3H18.75C19.1478 3 19.5294 3.15804 19.8107 3.43934C20.092 3.72064 20.25 4.10218 20.25 4.5ZM9 3H5.25C4.85218 3 4.47064 3.15804 4.18934 3.43934C3.90804 3.72064 3.75 4.10218 3.75 4.5V19.5C3.75 19.8978 3.90804 20.2794 4.18934 20.5607C4.47064 20.842 4.85218 21 5.25 21H9C9.39782 21 9.77936 20.842 10.0607 20.5607C10.342 20.2794 10.5 19.8978 10.5 19.5V4.5C10.5 4.10218 10.342 3.72064 10.0607 3.43934C9.77936 3.15804 9.39782 3 9 3Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Play({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Play">
      <path
        d="M22.5 12C22.5006 12.2547 22.4353 12.5051 22.3105 12.7271C22.1856 12.949 22.0055 13.1349 21.7875 13.2666L8.28 21.5297C8.05227 21.6691 7.79144 21.7453 7.52445 21.7502C7.25746 21.7552 6.99399 21.6887 6.76125 21.5578C6.53073 21.4289 6.3387 21.241 6.2049 21.0133C6.07111 20.7855 6.00039 20.5263 6 20.2622V3.73782C6.00039 3.47371 6.07111 3.21448 6.2049 2.98676C6.3387 2.75905 6.53073 2.57109 6.76125 2.4422C6.99399 2.31127 7.25746 2.24486 7.52445 2.2498C7.79144 2.25474 8.05227 2.33087 8.28 2.47032L21.7875 10.7334C22.0055 10.8651 22.1856 11.051 22.3105 11.2729C22.4353 11.4949 22.5006 11.7454 22.5 12Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function ThumbsDownFill({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ThumbsDownFill">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 5.375V13.375H6.625V5.375H3.125ZM6.95922 15.125H3C2.56902 15.125 2.1557 14.9538 1.85095 14.649C1.5462 14.3443 1.375 13.931 1.375 13.5V5.25C1.375 4.81902 1.5462 4.4057 1.85095 4.10095C2.1557 3.79621 2.56902 3.625 3 3.625H19.125C19.7034 3.62516 20.262 3.83636 20.6957 4.21897C21.1295 4.60158 21.4087 5.1293 21.4809 5.70312L22.6059 14.7031C22.6481 15.0374 22.6186 15.3768 22.5195 15.6988C22.4203 16.0207 22.2539 16.318 22.031 16.5707C21.8082 16.8234 21.5342 17.0258 21.2272 17.1645C20.9202 17.3031 20.5871 17.3749 20.2502 17.375H15.125V18.75C15.125 19.7777 14.7167 20.7633 13.99 21.49C13.2633 22.2167 12.2777 22.625 11.25 22.625C10.9186 22.625 10.6156 22.4377 10.4674 22.1413L6.95922 15.125Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function ThumbsUpFill({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ThumbsUpFill">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4674 1.85869C10.6156 1.56225 10.9186 1.375 11.25 1.375C12.2777 1.375 13.2633 1.78326 13.99 2.50996C14.7167 3.23666 15.125 4.22229 15.125 5.25V6.625H20.25C20.5869 6.62509 20.9202 6.69686 21.2272 6.83554C21.5342 6.97422 21.8082 7.17663 22.031 7.42934C22.2539 7.68204 22.4203 7.97926 22.5195 8.30124C22.6186 8.62323 22.6481 8.96262 22.6059 9.29688L21.4811 18.296C21.4088 18.8699 21.1295 19.3984 20.6957 19.781C20.262 20.1636 19.7036 20.3748 19.1252 20.375H3C2.56902 20.375 2.1557 20.2038 1.85095 19.899C1.5462 19.5943 1.375 19.181 1.375 18.75V10.5C1.375 10.069 1.54621 9.6557 1.85095 9.35095C2.1557 9.04621 2.56902 8.875 3 8.875H6.95922L10.4674 1.85869ZM6.625 10.625H3.125V18.625H6.625V10.625Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function ThumbsDown({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ThumbsDown">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 5.375V13.375H6.625V5.375H3.125ZM8.375 5.375V14.0434L11.7598 20.813C12.1325 20.7208 12.4766 20.5286 12.7526 20.2526C13.1511 19.8541 13.375 19.3136 13.375 18.75V16.5C13.375 16.0168 13.7668 15.625 14.25 15.625H20.2498C20.2497 15.625 20.2498 15.625 20.2498 15.625C20.3383 15.6249 20.4261 15.6061 20.5068 15.5696C20.5876 15.5331 20.6598 15.4798 20.7184 15.4133C20.777 15.3468 20.8208 15.2686 20.8469 15.1839C20.873 15.0991 20.8808 15.0098 20.8697 14.9219L19.7447 5.92188C19.7257 5.77087 19.6522 5.632 19.538 5.53131C19.424 5.43068 19.2771 5.3751 19.125 5.375H8.375ZM6.95922 15.125H3C2.56902 15.125 2.1557 14.9538 1.85095 14.649C1.5462 14.3443 1.375 13.931 1.375 13.5V5.25C1.375 4.81902 1.5462 4.4057 1.85095 4.10095C2.1557 3.79621 2.56902 3.625 3 3.625H19.125C19.7034 3.62516 20.262 3.83636 20.6957 4.21897C21.1295 4.60158 21.4087 5.1293 21.4809 5.70312L22.6059 14.7031C22.6481 15.0374 22.6186 15.3768 22.5195 15.6988C22.4203 16.0207 22.2539 16.318 22.031 16.5707C21.8082 16.8234 21.5342 17.0258 21.2272 17.1645C20.9202 17.3031 20.5871 17.3749 20.2502 17.375H15.125V18.75C15.125 19.7777 14.7167 20.7633 13.99 21.49C13.2633 22.2167 12.2777 22.625 11.25 22.625C10.9186 22.625 10.6156 22.4377 10.4674 22.1413L6.95922 15.125Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function ThumbsUp({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ThumbsUp">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4674 1.85869C10.6156 1.56225 10.9186 1.375 11.25 1.375C12.2777 1.375 13.2633 1.78326 13.99 2.50996C14.7167 3.23666 15.125 4.22229 15.125 5.25V6.625H20.25C20.5869 6.62509 20.9202 6.69686 21.2272 6.83554C21.5342 6.97422 21.8082 7.17663 22.031 7.42934C22.2539 7.68204 22.4203 7.97926 22.5195 8.30124C22.6186 8.62323 22.6481 8.96262 22.6059 9.29688L21.4811 18.296C21.4088 18.8699 21.1295 19.3984 20.6957 19.781C20.262 20.1636 19.7036 20.3748 19.1252 20.375H3C2.56902 20.375 2.1557 20.2038 1.85095 19.899C1.5462 19.5943 1.375 19.181 1.375 18.75V10.5C1.375 10.069 1.54621 9.6557 1.85095 9.35095C2.1557 9.04621 2.56902 8.875 3 8.875H6.95922L10.4674 1.85869ZM6.625 10.625H3.125V18.625H6.625V10.625ZM8.375 18.625H19.1248C19.1247 18.625 19.1248 18.625 19.1248 18.625C19.2769 18.6249 19.424 18.5693 19.538 18.4687C19.6522 18.368 19.7257 18.2291 19.7447 18.0781L20.8696 9.07897C20.8807 8.99101 20.873 8.90085 20.8469 8.81612C20.8208 8.73138 20.777 8.65317 20.7184 8.58667C20.6598 8.52017 20.5876 8.4669 20.5068 8.43041C20.4261 8.39395 20.3386 8.37506 20.25 8.375C20.2499 8.375 20.2501 8.375 20.25 8.375H14.25C13.7668 8.375 13.375 7.98325 13.375 7.5V5.25C13.375 4.68642 13.1511 4.14591 12.7526 3.7474C12.4766 3.47139 12.1325 3.27915 11.7598 3.18704L8.375 9.95656V18.625Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Question({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Question">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.875 9C5.875 5.90977 8.74845 3.625 12 3.625C15.2516 3.625 18.125 5.90977 18.125 9C18.125 11.8095 15.75 13.9532 12.875 14.3195V15C12.875 15.4832 12.4832 15.875 12 15.875C11.5168 15.875 11.125 15.4832 11.125 15V13.5C11.125 13.0168 11.5168 12.625 12 12.625C14.5478 12.625 16.375 10.8804 16.375 9C16.375 7.1196 14.5478 5.375 12 5.375C9.45218 5.375 7.625 7.1196 7.625 9C7.625 9.48325 7.23325 9.875 6.75 9.875C6.26675 9.875 5.875 9.48325 5.875 9ZM10.3733 19.5C10.3733 18.6016 11.1016 17.8733 12 17.8733C12.8984 17.8733 13.6267 18.6016 13.6267 19.5C13.6267 20.3984 12.8984 21.1267 12 21.1267C11.1016 21.1267 10.3733 20.3984 10.3733 19.5Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function More({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="More">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.37411 12C4.37411 11.3092 4.93416 10.7491 5.625 10.7491C6.31585 10.7491 6.87589 11.3092 6.87589 12C6.87589 12.6908 6.31585 13.2509 5.625 13.2509C4.93416 13.2509 4.37411 12.6908 4.37411 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7491 12C10.7491 11.3092 11.3092 10.7491 12 10.7491C12.6908 10.7491 13.2509 11.3092 13.2509 12C13.2509 12.6908 12.6908 13.2509 12 13.2509C11.3092 13.2509 10.7491 12.6908 10.7491 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1241 12C17.1241 11.3092 17.6842 10.7491 18.375 10.7491C19.0658 10.7491 19.6259 11.3092 19.6259 12C19.6259 12.6908 19.0658 13.2509 18.375 13.2509C17.6842 13.2509 17.1241 12.6908 17.1241 12Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function SmallArrowDown({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SmallArrowDown">
      <path d="M12 15.75L6 9.75L18 9.75L12 15.75Z" fill="currentColor" />
    </Svg>
  );
}

export function SmallArrowLeft({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SmallArrowLeft">
      <path d="M8.25 12L14.25 6L14.25 18L8.25 12Z" fill="currentColor" />
    </Svg>
  );
}

export function SmallArrowRight({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SmallArrowRight">
      <path d="M15.75 12L9.75 18L9.75 6L15.75 12Z" fill="currentColor" />
    </Svg>
  );
}

export function SmallArrowUp({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SmallArrowUp">
      <path d="M12 8.25L18 14.25L6 14.25L12 8.25Z" fill="currentColor" />
    </Svg>
  );
}
export function Swap({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Swap">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.85095 3.35095C8.1557 3.04621 8.56902 2.875 9 2.875H19.5C19.931 2.875 20.3443 3.0462 20.649 3.35095C20.9538 3.6557 21.125 4.06902 21.125 4.5V14.25C21.125 14.681 20.9538 15.0943 20.649 15.399C20.3443 15.7038 19.931 15.875 19.5 15.875H9.61244L10.3687 16.6313C10.7104 16.973 10.7104 17.527 10.3687 17.8687C10.027 18.2104 9.47299 18.2104 9.13128 17.8687L6.88128 15.6187C6.53957 15.277 6.53957 14.723 6.88128 14.3813L9.13128 12.1313C9.47299 11.7896 10.027 11.7896 10.3687 12.1313C10.7104 12.473 10.7104 13.027 10.3687 13.3687L9.61244 14.125H19.375V4.625H9.125V5.25C9.125 5.73325 8.73325 6.125 8.25 6.125C7.76675 6.125 7.375 5.73325 7.375 5.25V4.5C7.375 4.06902 7.54621 3.6557 7.85095 3.35095ZM13.6313 6.13128C13.973 5.78957 14.527 5.78957 14.8687 6.13128L17.1187 8.38128C17.4604 8.72299 17.4604 9.27701 17.1187 9.61872L14.8687 11.8687C14.527 12.2104 13.973 12.2104 13.6313 11.8687C13.2896 11.527 13.2896 10.973 13.6313 10.6313L14.3876 9.875H4.625V19.375H14.875V18.75C14.875 18.2668 15.2668 17.875 15.75 17.875C16.2332 17.875 16.625 18.2668 16.625 18.75V19.5C16.625 19.931 16.4538 20.3443 16.149 20.649C15.8443 20.9538 15.431 21.125 15 21.125H4.5C4.06902 21.125 3.6557 20.9538 3.35095 20.649C3.0462 20.3443 2.875 19.931 2.875 19.5V9.75C2.875 9.31902 3.04621 8.9057 3.35095 8.60095C3.6557 8.29621 4.06902 8.125 4.5 8.125H14.3876L13.6313 7.36872C13.2896 7.02701 13.2896 6.47299 13.6313 6.13128Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function ImageSquare({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ImageSquare">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.625 4.625V19.375H4.95224L14.9753 9.35101C14.9754 9.35091 14.9755 9.3508 14.9756 9.3507C15.1265 9.19975 15.3056 9.08001 15.5027 8.99829C15.7 8.91651 15.9115 8.87442 16.125 8.87442C16.3386 8.87442 16.55 8.91651 16.7473 8.99829C16.9444 9.08002 17.1236 9.19978 17.2744 9.35075C17.2745 9.35084 17.2746 9.35092 17.2747 9.35101L19.375 11.4519V4.625H4.625ZM21.125 13.5632V4.5C21.125 3.60254 20.3975 2.875 19.5 2.875H4.5C3.60254 2.875 2.875 3.60254 2.875 4.5V19.5C2.875 20.3975 3.60254 21.125 4.5 21.125H5.31059C5.31332 21.125 5.31606 21.125 5.31879 21.125H19.5C20.3975 21.125 21.125 20.3975 21.125 19.5V13.5661C21.125 13.5652 21.125 13.5642 21.125 13.5632ZM19.375 13.9271L16.125 10.6762L7.427 19.375H19.375V13.9271ZM16.2134 10.5878C16.2133 10.5879 16.2132 10.588 16.2131 10.5881L16.2134 10.5878ZM9 8.375C8.65482 8.375 8.375 8.65482 8.375 9C8.375 9.34518 8.65482 9.625 9 9.625C9.34518 9.625 9.625 9.34518 9.625 9C9.625 8.65482 9.34518 8.375 9 8.375ZM6.625 9C6.625 7.68832 7.68832 6.625 9 6.625C10.3117 6.625 11.375 7.68832 11.375 9C11.375 10.3117 10.3117 11.375 9 11.375C7.68832 11.375 6.625 10.3117 6.625 9Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Layout({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Layout">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.875 5.375V8.875H20.125V5.375H3.875ZM21.875 5.25C21.875 4.35254 21.1475 3.625 20.25 3.625H3.75C2.85254 3.625 2.125 4.35254 2.125 5.25V18.75C2.125 19.6475 2.85254 20.375 3.75 20.375H20.25C21.1475 20.375 21.875 19.6475 21.875 18.75V5.25ZM20.125 10.625H10.625V18.625H20.125V10.625ZM8.875 18.625V10.625H3.875V18.625H8.875Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function UserCircle({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="UserCircle">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6997 3.875C8.21239 3.875 4.57471 7.51269 4.57471 12C4.57471 14.0144 5.30781 15.8577 6.52177 17.2774C7.1084 16.4665 7.85133 15.7758 8.71094 15.2481C9.0207 15.058 9.34249 14.891 9.67367 14.7478C8.69428 13.8997 8.07471 12.6472 8.07471 11.25C8.07471 8.69568 10.1454 6.625 12.6997 6.625C15.254 6.625 17.3247 8.69568 17.3247 11.25C17.3247 12.6472 16.7051 13.8997 15.7257 14.7478C16.0569 14.891 16.3787 15.058 16.6885 15.2481C17.5481 15.7758 18.291 16.4665 18.8777 17.2774C20.0916 15.8577 20.8247 14.0144 20.8247 12C20.8247 7.51269 17.187 3.875 12.6997 3.875ZM17.5893 18.4896C17.1192 17.784 16.5003 17.186 15.773 16.7396C14.8863 16.1953 13.8715 15.8967 12.8328 15.8731C12.7886 15.8744 12.7442 15.875 12.6997 15.875C12.6552 15.875 12.6108 15.8744 12.5666 15.8731C11.5279 15.8967 10.5132 16.1953 9.62639 16.7396C8.89911 17.186 8.28022 17.784 7.81016 18.4896C9.17059 19.5163 10.8641 20.125 12.6997 20.125C14.5354 20.125 16.2288 19.5163 17.5893 18.4896ZM12.8194 14.1226C14.3517 14.0598 15.5747 12.7977 15.5747 11.25C15.5747 9.66218 14.2875 8.375 12.6997 8.375C11.1119 8.375 9.82471 9.66218 9.82471 11.25C9.82471 12.7977 11.0477 14.0598 12.58 14.1226C12.6199 14.1219 12.6598 14.1216 12.6997 14.1216C12.7396 14.1216 12.7796 14.1219 12.8194 14.1226ZM2.82471 12C2.82471 6.54619 7.24589 2.125 12.6997 2.125C18.1535 2.125 22.5747 6.54619 22.5747 12C22.5747 17.4538 18.1535 21.875 12.6997 21.875C7.24589 21.875 2.82471 17.4538 2.82471 12Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function SortAscending({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SortAscending">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.625 6C3.625 5.51675 4.01675 5.125 4.5 5.125H17.25C17.7332 5.125 18.125 5.51675 18.125 6C18.125 6.48325 17.7332 6.875 17.25 6.875H4.5C4.01675 6.875 3.625 6.48325 3.625 6ZM17.25 9.625C17.7332 9.625 18.125 10.0168 18.125 10.5V17.3876L20.3813 15.1313C20.723 14.7896 21.277 14.7896 21.6187 15.1313C21.9604 15.473 21.9604 16.027 21.6187 16.3687L17.8687 20.1187C17.527 20.4604 16.973 20.4604 16.6313 20.1187L12.8813 16.3687C12.5396 16.027 12.5396 15.473 12.8813 15.1313C13.223 14.7896 13.777 14.7896 14.1187 15.1313L16.375 17.3876V10.5C16.375 10.0168 16.7668 9.625 17.25 9.625ZM3.625 12C3.625 11.5168 4.01675 11.125 4.5 11.125H11.25C11.7332 11.125 12.125 11.5168 12.125 12C12.125 12.4832 11.7332 12.875 11.25 12.875H4.5C4.01675 12.875 3.625 12.4832 3.625 12ZM3.625 18C3.625 17.5168 4.01675 17.125 4.5 17.125H9.75C10.2332 17.125 10.625 17.5168 10.625 18C10.625 18.4832 10.2332 18.875 9.75 18.875H4.5C4.01675 18.875 3.625 18.4832 3.625 18Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function SortDescending({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SortDescending">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6313 3.88128C16.973 3.53957 17.527 3.53957 17.8687 3.88128L21.6187 7.63128C21.9604 7.97299 21.9604 8.52701 21.6187 8.86872C21.277 9.21043 20.723 9.21043 20.3813 8.86872L18.125 6.61244V13.5C18.125 13.9832 17.7332 14.375 17.25 14.375C16.7668 14.375 16.375 13.9832 16.375 13.5V6.61244L14.1187 8.86872C13.777 9.21043 13.223 9.21043 12.8813 8.86872C12.5396 8.52701 12.5396 7.97299 12.8813 7.63128L16.6313 3.88128ZM3.625 6C3.625 5.51675 4.01675 5.125 4.5 5.125H9.75C10.2332 5.125 10.625 5.51675 10.625 6C10.625 6.48325 10.2332 6.875 9.75 6.875H4.5C4.01675 6.875 3.625 6.48325 3.625 6ZM3.625 12C3.625 11.5168 4.01675 11.125 4.5 11.125H11.25C11.7332 11.125 12.125 11.5168 12.125 12C12.125 12.4832 11.7332 12.875 11.25 12.875H4.5C4.01675 12.875 3.625 12.4832 3.625 12ZM3.625 18C3.625 17.5168 4.01675 17.125 4.5 17.125H17.25C17.7332 17.125 18.125 17.5168 18.125 18C18.125 18.4832 17.7332 18.875 17.25 18.875H4.5C4.01675 18.875 3.625 18.4832 3.625 18Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Certificate({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Certificate">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 17.875H20.875V9.875H3.125V17.875ZM12.75 14.875C13.2332 14.875 13.625 15.2668 13.625 15.75C13.625 16.2332 13.2332 16.625 12.75 16.625H11.25C10.7668 16.625 10.375 16.2332 10.375 15.75C10.375 15.2668 10.7668 14.875 11.25 14.875H12.75ZM18.75 14.875C19.2332 14.875 19.625 15.2668 19.625 15.75C19.625 16.2332 19.2332 16.625 18.75 16.625H15.75C15.2668 16.625 14.875 16.2332 14.875 15.75C14.875 15.2668 15.2668 14.875 15.75 14.875H18.75ZM3.125 8.125H20.875V6.125H3.125V8.125ZM22.625 18C22.625 18.8975 21.8975 19.625 21 19.625H3C2.10254 19.625 1.375 18.8975 1.375 18V6C1.375 5.10254 2.10254 4.375 3 4.375H21C21.8975 4.375 22.625 5.10254 22.625 6V18Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Promocode({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Promocode">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.63745 12.3867L13.825 21.5732L21.5857 13.8105L12.4001 4.625H4.63745V12.3867ZM23.3875 13.8105C23.3875 14.2413 23.2163 14.6543 22.9119 14.959L14.9753 22.8994C14.6706 23.2039 14.2567 23.375 13.8259 23.375C13.4491 23.375 13.0857 23.2444 12.7966 23.0078L12.6775 22.8994L3.36304 13.5879C3.05895 13.2835 2.88774 12.8707 2.88745 12.4404V3.75L2.89233 3.66016C2.93733 3.21913 3.30955 2.875 3.76245 2.875H12.4529L12.613 2.88281C12.9314 2.91454 13.2336 3.03956 13.4812 3.24219L13.6003 3.35059L22.9119 12.6621L23.0203 12.7812C23.2569 13.0703 23.3874 13.4338 23.3875 13.8105Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88745 9C8.50877 9 9.01245 8.49632 9.01245 7.875C9.01245 7.25368 8.50877 6.75 7.88745 6.75C7.26613 6.75 6.76245 7.25368 6.76245 7.875C6.76245 8.49632 7.26613 9 7.88745 9Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Cross({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Cross">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.631 4.631a.875.875 0 0 1 1.238 0L12 10.763l6.131-6.132A.875.875 0 1 1 19.37 5.87L13.237 12l6.132 6.131a.875.875 0 1 1-1.238 1.238L12 13.237 5.869 19.37A.875.875 0 0 1 4.63 18.13L10.763 12 4.63 5.869a.875.875 0 0 1 0-1.238Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Phone({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Phone">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.65354 3.80011L7.65439 3.80205L7.65354 3.80011ZM7.69308 3.88876L9.601 8.15064L7.70409 10.4062C7.68269 10.4316 7.66275 10.4583 7.64438 10.486C7.48967 10.7194 7.39819 10.989 7.37887 11.2684C7.35955 11.5478 7.41307 11.8274 7.53417 12.0799L7.53691 12.0856C8.39955 13.8515 10.1844 15.6136 11.9508 16.4656L11.9555 16.4678C12.2095 16.5885 12.4906 16.6408 12.7711 16.6197C13.0515 16.5986 13.3216 16.5047 13.5546 16.3473C13.5815 16.3292 13.6073 16.3096 13.6319 16.2887L15.8531 14.3994L20.1118 16.3075C19.9753 17.1456 19.5509 17.9114 18.91 18.4718C18.243 19.0551 17.3868 19.3763 16.5007 19.3756C13.3512 19.3756 10.3301 18.1245 8.10311 15.8975C5.87611 13.6705 4.625 10.65 4.625 7.50059C4.62432 6.61448 4.94549 5.75762 5.52878 5.09057C6.0892 4.44967 6.85493 4.02529 7.69308 3.88876ZM7.57678 2.13733C7.92541 2.09591 8.27807 2.16851 8.58199 2.34427C8.88335 2.51855 9.12071 2.78497 9.25921 3.10419L11.2377 7.52369L11.2434 7.53676C11.3489 7.783 11.3918 8.0515 11.3684 8.31835C11.345 8.58521 11.256 8.84214 11.1093 9.06629C11.0902 9.09553 11.0693 9.1236 11.0468 9.15034L9.15217 11.4032C9.8435 12.7572 11.2627 14.1608 12.6256 14.8472L14.8446 12.9597C14.8708 12.9375 14.8982 12.9168 14.9268 12.8978C15.1519 12.748 15.4107 12.6568 15.6799 12.6323C15.9491 12.6078 16.2202 12.6509 16.4685 12.7576L16.4809 12.7629L20.8965 14.7414C21.2157 14.88 21.4821 15.1173 21.6563 15.4186C21.8321 15.7225 21.9047 16.0752 21.8633 16.4238L21.8617 16.4367C21.688 17.7353 21.0483 18.9267 20.062 19.7892C19.0756 20.6517 17.8096 21.1266 16.4993 21.1256C12.886 21.1254 9.4207 19.6899 6.86567 17.1349C4.31055 14.5798 2.87507 11.1143 2.875 7.50085M7.57678 2.13733L7.56395 2.13895L7.57678 2.13733ZM7.56395 2.13895C6.26526 2.31273 5.07389 2.95226 4.2114 3.93861L7.56395 2.13895ZM4.2114 3.93861C3.34905 4.9248 2.87416 6.19083 2.875 7.50085L4.2114 3.93861Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.57678 2.13733L7.56395 2.13895L4.2114 3.93861L5.2226 4.82284L7.57678 2.13733Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2114 3.93861L2.875 7.50085L5.2226 4.82284L4.2114 3.93861Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Mail({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Mail">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 5.25C2.125 4.76675 2.51675 4.375 3 4.375H21C21.4832 4.375 21.875 4.76675 21.875 5.25V18C21.875 18.431 21.7038 18.8443 21.399 19.149C21.0943 19.4538 20.681 19.625 20.25 19.625H3.75C3.31902 19.625 2.9057 19.4538 2.60095 19.149C2.2962 18.8443 2.125 18.431 2.125 18V5.25ZM5.24945 6.125L12 12.313L18.7505 6.125H5.24945ZM20.125 7.23908L12.5913 14.145C12.2567 14.4517 11.7433 14.4517 11.4087 14.145L3.875 7.23908V17.875H20.125V7.23908Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Chain({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Chain">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5005 8.2717C22.4629 9.57732 21.9261 10.8188 21.0005 11.7405L17.7427 15.0001C17.2682 15.4772 16.7038 15.8554 16.0822 16.1129C15.4606 16.3704 14.794 16.502 14.1212 16.5001H14.1165C13.4321 16.4997 12.7548 16.362 12.1246 16.0954C11.4943 15.8287 10.9239 15.4385 10.447 14.9477C9.97007 14.4569 9.59636 13.8755 9.34793 13.2378C9.09949 12.6002 8.98137 11.9192 9.00053 11.2351C9.00613 11.0362 9.09051 10.8477 9.23512 10.711C9.37973 10.5743 9.57272 10.5006 9.77163 10.5062C9.97054 10.5118 10.1591 10.5962 10.2958 10.7408C10.4325 10.8854 10.5061 11.0784 10.5005 11.2773C10.4869 11.761 10.5703 12.2425 10.7459 12.6934C10.9215 13.1443 11.1857 13.5554 11.5229 13.9025C11.86 14.2495 12.2634 14.5255 12.709 14.714C13.1546 14.9025 13.6335 14.9998 14.1174 15.0001C14.5931 15.0014 15.0642 14.9083 15.5037 14.7263C15.9432 14.5443 16.3422 14.277 16.6777 13.9398L19.9355 10.682C20.6077 10.0014 20.9833 9.0825 20.9803 8.12593C20.9773 7.16936 20.596 6.25283 19.9196 5.57643C19.2432 4.90003 18.3266 4.51871 17.3701 4.51572C16.4135 4.51272 15.4946 4.8883 14.814 5.56045L13.7827 6.5917C13.6409 6.72642 13.4521 6.80041 13.2565 6.79791C13.061 6.7954 12.8741 6.7166 12.7358 6.5783C12.5975 6.44 12.5187 6.25314 12.5162 6.05757C12.5137 5.862 12.5877 5.67319 12.7224 5.53139L13.7537 4.50014C14.2294 4.0242 14.7943 3.64665 15.416 3.38907C16.0378 3.13148 16.7041 2.9989 17.3771 2.9989C18.0501 2.9989 18.7164 3.13148 19.3382 3.38907C19.9599 3.64665 20.5248 4.0242 21.0005 4.50014C21.4933 4.99416 21.8805 5.5833 22.1383 6.23169C22.3962 6.88008 22.5194 7.57417 22.5005 8.2717ZM10.2193 17.4058L9.18803 18.437C8.85168 18.7756 8.45138 19.044 8.01039 19.2265C7.56941 19.409 7.09654 19.502 6.61928 19.5001C5.90332 19.4996 5.20359 19.2868 4.6085 18.8887C4.01342 18.4906 3.54968 17.925 3.27589 17.2635C3.0021 16.6019 2.93054 15.8741 3.07026 15.1719C3.20997 14.4697 3.55468 13.8246 4.06085 13.3183L7.31303 10.0605C7.82527 9.54551 8.48051 9.19649 9.19365 9.05872C9.90679 8.92095 10.6449 9.0008 11.3121 9.28789C11.9792 9.57498 12.5447 10.056 12.935 10.6686C13.3252 11.2812 13.5223 11.997 13.5005 12.723C13.4949 12.9219 13.5686 13.1149 13.7053 13.2595C13.842 13.4041 14.0305 13.4885 14.2294 13.494C14.4284 13.4996 14.6213 13.426 14.7659 13.2893C14.9106 13.1526 14.9949 12.9641 15.0005 12.7651C15.0185 12.0687 14.8949 11.3759 14.637 10.7287C14.3792 10.0815 13.9925 9.4934 13.5005 9.00014C12.5398 8.03979 11.2369 7.50031 9.8785 7.50031C8.52007 7.50031 7.21724 8.03979 6.25647 9.00014L3.00054 12.258C2.2845 12.9737 1.79671 13.8856 1.59879 14.8785C1.40088 15.8714 1.50174 16.9007 1.88861 17.8363C2.27549 18.7718 2.93102 19.5718 3.77237 20.1349C4.61372 20.698 5.60312 20.9991 6.61553 21.0001C7.28854 21.0021 7.95524 20.8705 8.57705 20.613C9.19885 20.3556 9.76341 19.9773 10.238 19.5001L11.2693 18.4689C11.3907 18.3259 11.4541 18.1427 11.447 17.9553C11.44 17.7679 11.3629 17.5899 11.2312 17.4565C11.0994 17.323 10.9224 17.2438 10.7351 17.2344C10.5478 17.2251 10.3637 17.2862 10.2193 17.4058Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Gift({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Gift">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6154 8.0409H16.5796C16.6134 8.01121 16.648 7.98241 16.6809 7.95091C16.9437 7.70809 17.1555 7.41148 17.3031 7.07964C17.4506 6.7478 17.5308 6.38786 17.5385 6.02235C17.5498 5.62248 17.4825 5.22442 17.3406 4.8526C17.1987 4.48077 16.9852 4.14304 16.7132 3.86013C16.4412 3.57721 16.1165 3.35509 15.759 3.2074C15.4015 3.0597 15.0187 2.98955 14.6342 3.00126C14.2826 3.00913 13.9363 3.09241 13.6171 3.24587C13.2978 3.39932 13.0124 3.61966 12.7788 3.89309C12.4556 4.28267 12.1928 4.72233 12 5.1962C11.8072 4.72233 11.5444 4.28267 11.2212 3.89309C10.9876 3.61966 10.7022 3.39932 10.3829 3.24587C10.0637 3.09241 9.7174 3.00913 9.36577 3.00126C8.98125 2.98955 8.59849 3.0597 8.24099 3.2074C7.88349 3.35509 7.55878 3.57721 7.28681 3.86013C7.01484 4.14304 6.80135 4.48077 6.65943 4.8526C6.51751 5.22442 6.45017 5.62248 6.46154 6.02235C6.46923 6.38786 6.54936 6.7478 6.69693 7.07964C6.84449 7.41148 7.05631 7.70809 7.31914 7.95091C7.35202 7.98061 7.38663 8.00941 7.42038 8.0409H4.38462C4.01739 8.0409 3.66521 8.19261 3.40554 8.46264C3.14588 8.73268 3 9.09892 3 9.4808V12.3606C3 12.7425 3.14588 13.1087 3.40554 13.3788C3.66521 13.6488 4.01739 13.8005 4.38462 13.8005V19.5601C4.38462 19.942 4.53049 20.3082 4.79016 20.5783C5.04983 20.8483 5.40201 21 5.76923 21H18.2308C18.598 21 18.9502 20.8483 19.2098 20.5783C19.4695 20.3082 19.6154 19.942 19.6154 19.5601V13.8005C19.9826 13.8005 20.3348 13.6488 20.5945 13.3788C20.8541 13.1087 21 12.7425 21 12.3606V9.4808C21 9.09892 20.8541 8.73268 20.5945 8.46264C20.3348 8.19261 19.9826 8.0409 19.6154 8.0409ZM13.8173 4.84703C13.9269 4.72114 14.0604 4.62019 14.2093 4.5505C14.3582 4.48081 14.5194 4.44389 14.6827 4.44206H14.7251C14.9165 4.4433 15.1057 4.48426 15.2817 4.56253C15.4577 4.6408 15.6169 4.75482 15.7499 4.89789C15.883 5.04096 15.9873 5.21021 16.0566 5.39572C16.126 5.58124 16.159 5.77928 16.1538 5.97825C16.1521 6.14807 16.1166 6.31567 16.0496 6.47054C15.9826 6.6254 15.8855 6.76419 15.7644 6.87819C14.9432 7.63413 13.5802 7.90051 12.7356 7.99411C12.8394 7.04107 13.125 5.65607 13.8173 4.84703ZM8.27106 4.87943C8.53928 4.60053 8.90253 4.44302 9.28183 4.44116H9.32423C9.48753 4.44299 9.6487 4.47991 9.79762 4.5496C9.94654 4.61929 10.08 4.72024 10.1896 4.84613C10.9157 5.69927 11.1718 7.11397 11.2618 7.98871C10.4207 7.89871 9.06029 7.62873 8.2399 6.87369C8.11885 6.75969 8.02177 6.62091 7.95476 6.46604C7.88774 6.31117 7.85224 6.14356 7.85048 5.97375C7.84511 5.77147 7.87932 5.57017 7.95102 5.38206C8.02272 5.19395 8.13043 5.02294 8.2676 4.87943H8.27106ZM4.38462 9.4808H11.3077V12.3606H4.38462V9.4808ZM5.76923 13.8005H11.3077V19.5601H5.76923V13.8005ZM18.2308 19.5601H12.6923V13.8005H18.2308V19.5601ZM19.6154 12.3606H12.6923V9.4808H19.6154V12.3606Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Desktop({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Desktop">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 5.25C4.08579 5.25 3.75 5.58579 3.75 6V13.5H20.25V6C20.25 5.58579 19.9142 5.25 19.5 5.25H4.5ZM21.75 6C21.75 4.75736 20.7426 3.75 19.5 3.75H4.5C3.25736 3.75 2.25 4.75736 2.25 6V16.5C2.25 17.7426 3.25736 18.75 4.5 18.75H11.25V20.25H9C8.58579 20.25 8.25 20.5858 8.25 21C8.25 21.4142 8.58579 21.75 9 21.75H15C15.4142 21.75 15.75 21.4142 15.75 21C15.75 20.5858 15.4142 20.25 15 20.25H12.75V18.75H19.5C20.7426 18.75 21.75 17.7426 21.75 16.5V6ZM20.25 15H3.75V16.5C3.75 16.9142 4.08579 17.25 4.5 17.25H19.5C19.9142 17.25 20.25 16.9142 20.25 16.5V15Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Mobile({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Mobile">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 3C7.08579 3 6.75 3.33579 6.75 3.75V4.5H17.25V3.75C17.25 3.33579 16.9142 3 16.5 3H7.5ZM18.75 3.75C18.75 2.50736 17.7426 1.5 16.5 1.5H7.5C6.25736 1.5 5.25 2.50736 5.25 3.75V20.25C5.25 21.4926 6.25736 22.5 7.5 22.5H16.5C17.7426 22.5 18.75 21.4926 18.75 20.25V3.75ZM17.25 6H6.75V18H17.25V6ZM17.25 19.5H6.75V20.25C6.75 20.6642 7.08579 21 7.5 21H16.5C16.9142 21 17.25 20.6642 17.25 20.25V19.5Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Info({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Info">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.125C7.51269 20.125 3.875 16.4873 3.875 12C3.875 7.51269 7.51269 3.875 12 3.875C16.4873 3.875 20.125 7.51269 20.125 12C20.125 16.4873 16.4873 20.125 12 20.125ZM2.125 12C2.125 17.4538 6.54619 21.875 12 21.875C17.4538 21.875 21.875 17.4538 21.875 12C21.875 6.54619 17.4538 2.125 12 2.125C6.54619 2.125 2.125 6.54619 2.125 12ZM12 17.375C12.4832 17.375 12.875 16.9832 12.875 16.5V11.25C12.875 10.7668 12.4832 10.375 12 10.375C11.5168 10.375 11.125 10.7668 11.125 11.25V16.5C11.125 16.9832 11.5168 17.375 12 17.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.75C12.6213 6.75 13.125 7.25368 13.125 7.875C13.125 8.49632 12.6213 9 12 9C11.3787 9 10.875 8.49632 10.875 7.875C10.875 7.25368 11.3787 6.75 12 6.75Z"
        fill="currentColor"
      />
    </Svg>
  );
}

/* STROKE ICONS */
const getStrokeProps = (size: number) => {
  type Linecap = 'round' | 'butt' | 'square' | 'inherit' | undefined;
  type Linejoin = 'round' | 'inherit' | 'miter' | 'bevel' | undefined;
  return {
    stroke: 'currentColor',
    strokeWidth: size / 16 + 0.25,
    strokeLinecap: 'round' as Linecap,
    strokeLinejoin: 'round' as Linejoin,
  };
};

export function Preview(props: ComponentProps<'svg'>) {
  return (
    <Svg {...props} data-icon="Preview">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 8.73V17M8 3h8a5 5 0 015 5v8a5 5 0 01-5 5H8a5 5 0 01-5-5V8a5 5 0 015-5zm9 5.5v6.16-.01c0 .43-.28.81-.69.94l-4 1.33h-.01c-.21.06-.43.06-.64-.01l-4-1.34a1.01 1.01 0 01-.69-.95V8.45l-.001-.01a.99.99 0 01.99-1.01c.1-.01.21.01.31.05l3.36 1.12-.01-.01c.2.06.42.06.63 0l3.36-1.13v-.01c.52-.18 1.09.1 1.26.63.03.1.05.2.05.31L17 8.5z"
      />
    </Svg>
  );
}

export function AllSpreads(props: ComponentProps<'svg'>) {
  return (
    <Svg width="32" height="24" viewBox="0 0 32 24" {...props} data-icon="AllSpreads">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22.5 13v8M9.5 3v8m11-2.5H25m0 0V4m0 4.5L19.5 3M7 20v-4.5m0 0h4.5m-4.5 0l5.5 5.5m5.5 0h9a1 1 0 001-1v-6a1 1 0 00-1-1h-9a1 1 0 00-1 1v6a1 1 0 001 1zM5 11h9a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v6a1 1 0 001 1z"
      />
    </Svg>
  );
}

export function Spread(props: ComponentProps<'svg'>) {
  return (
    <Svg width="32" height="24" viewBox="0 0 32 24" {...props} data-icon="Spread">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 3v18m-9.5 0h19a2.5 2.5 0 002.5-2.5v-13A2.5 2.5 0 0025.5 3h-19A2.5 2.5 0 004 5.5v13A2.5 2.5 0 006.5 21z"
      />
    </Svg>
  );
}

// TODO: порешать что делать с иконками и размерами
export function Loading({ size = 24, ...props }: ComponentProps<'svg'> & { size?: number }) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Loading">
      <path d="M12 3a9 9 0 1 1-9 9" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function Check({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Check">
      <path d="M3.75 13.5L9 18.75L21 6.75" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function Clock({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Clock">
      <path
        d="M12 6.75V12H17.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function Crosshair({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Crosshair">
      <path
        d="M12 21.75V18.75M12 2.25V5.25M2.25 12H5.25M21.75 12H18.75M20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function Home({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Home">
      <path
        d="M14.25 19.5V15C14.25 14.8011 14.171 14.6103 14.0303 14.4697C13.8897 14.329 13.6989 14.25 13.5 14.25H10.5C10.3011 14.25 10.1103 14.329 9.96967 14.4697C9.82902 14.6103 9.75 14.8011 9.75 15V19.5C9.75 19.6989 9.67098 19.8897 9.53033 20.0303C9.38968 20.171 9.19891 20.25 9 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V10.8319C3.75001 10.7274 3.77187 10.624 3.81416 10.5284C3.85646 10.4328 3.91827 10.3472 3.99562 10.2769L11.4956 3.195C11.6337 3.06931 11.8137 2.99965 12.0005 2.99965C12.1872 2.99965 12.3672 3.06931 12.5053 3.195L20.0053 10.2769C20.0827 10.3472 20.1445 10.4328 20.1868 10.5284C20.2291 10.624 20.2509 10.7274 20.2509 10.8319V19.5C20.2509 19.6989 20.1719 19.8897 20.0313 20.0303C19.8906 20.171 19.6998 20.25 19.5009 20.25H15C14.8011 20.25 14.6103 20.171 14.4697 20.0303C14.329 19.8897 14.25 19.6989 14.25 19.5Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function MagnifyingGlass({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="MagnifyingGlass">
      <path
        d="M15.8034 15.8034L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}
export function MapPin({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="MapPin">
      <path
        d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
        {...getStrokeProps(size)}
      />
      <path
        d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function SquaresFour({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SquaresFour">
      <path
        d="M9.75 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V9.75C4.5 10.1642 4.83579 10.5 5.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V5.25C10.5 4.83579 10.1642 4.5 9.75 4.5Z"
        {...getStrokeProps(size)}
      />
      <path
        d="M18.75 4.5H14.25C13.8358 4.5 13.5 4.83579 13.5 5.25V9.75C13.5 10.1642 13.8358 10.5 14.25 10.5H18.75C19.1642 10.5 19.5 10.1642 19.5 9.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5Z"
        {...getStrokeProps(size)}
      />
      <path
        d="M9.75 13.5H5.25C4.83579 13.5 4.5 13.8358 4.5 14.25V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H9.75C10.1642 19.5 10.5 19.1642 10.5 18.75V14.25C10.5 13.8358 10.1642 13.5 9.75 13.5Z"
        {...getStrokeProps(size)}
      />
      <path
        d="M18.75 13.5H14.25C13.8358 13.5 13.5 13.8358 13.5 14.25V18.75C13.5 19.1642 13.8358 19.5 14.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V14.25C19.5 13.8358 19.1642 13.5 18.75 13.5Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function UserSwitch({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="UserSwitch">
      <path
        d="M18.75 11.9999L21 14.2499M21 14.2499L23.25 11.9999M21 14.2499V11.9999C21.0007 10.0945 20.3966 8.23793 19.2748 6.69772C18.1529 5.15751 16.5711 4.01312 14.7573 3.42935C12.9434 2.84558 10.9911 2.85257 9.18147 3.44931C7.37185 4.04604 5.79832 5.20173 4.6875 6.74993M0.75 11.9999L3 9.74993M3 9.74993L5.25 11.9999M3 9.74993V11.9999C2.99929 13.9054 3.60337 15.7619 4.72524 17.3021C5.84712 18.8424 7.42888 19.9867 9.24273 20.5705C11.0566 21.1543 13.0089 21.1473 14.8185 20.5506C16.6282 19.9538 18.2017 18.7981 19.3125 17.2499"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}
export function ShoppingCard({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ShoppingCard">
      <path
        d="M16.875 17.25H7.79719C7.44591 17.2499 7.10579 17.1266 6.83612 16.9015C6.56646 16.6764 6.38435 16.3637 6.32156 16.0181L3.93 2.86594C3.8986 2.69313 3.80755 2.53681 3.67272 2.42425C3.53789 2.31169 3.36783 2.25003 3.19219 2.25H1.5M16.875 17.25C15.8395 17.25 15 18.0895 15 19.125C15 20.1605 15.8395 21 16.875 21C17.9105 21 18.75 20.1605 18.75 19.125C18.75 18.0895 17.9105 17.25 16.875 17.25ZM5.86406 13.5H17.6344C17.9857 13.4999 18.3258 13.3766 18.5954 13.1515C18.8651 12.9264 19.0472 12.6137 19.11 12.2681L20.25 6H4.5M9.75 19.125C9.75 20.1605 8.91053 21 7.875 21C6.83947 21 6 20.1605 6 19.125C6 18.0895 6.83947 17.25 7.875 17.25C8.91053 17.25 9.75 18.0895 9.75 19.125Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function SmallCheck({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="SmallCheck">
      <path d="M8.25 12.75L10.5 15L15.75 9.75" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function Export({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Export">
      <path
        d="M20.25 9.75L20.2491 3.75094L14.25 3.75M12.75 11.25L20.25 3.75M17.25 12.75V19.5C17.25 19.6989 17.171 19.8897 17.0303 20.0303C16.8897 20.171 16.6989 20.25 16.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V7.5C3.75 7.30109 3.82902 7.11032 3.96967 6.96967C4.11032 6.82902 4.30109 6.75 4.5 6.75H11.25"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function Import({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Import">
      <path
        d="M11.25 18.75L11.2491 12.7509L5.25 12.75M3.75 20.25L11.25 12.75M15 17.25H19.5C19.6989 17.25 19.8897 17.171 20.0303 17.0303C20.171 16.8897 20.25 16.6989 20.25 16.5V4.5C20.25 4.30109 20.171 4.11032 20.0303 3.96967C19.8897 3.82902 19.6989 3.75 19.5 3.75H7.5C7.30109 3.75 7.11032 3.82902 6.96967 3.96967C6.82902 4.11032 6.75 4.30109 6.75 4.5V9"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function Minus({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Minus">
      <path d="M3.75 12H20.25" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function Plus({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Plus">
      <path d="M3.75 12H20.25M12 3.75V20.25" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function CaretDown({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CaretDown">
      <path d="M19.5 9L12 16.5L4.5 9" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function CaretLeft({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CaretLeft">
      <path d="M15 19.5L7.5 12L15 4.5" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function CaretRight({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CaretRight">
      <path d="M9 4.5L16.5 12L9 19.5" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function CaretUp({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CaretUp">
      <path d="M4.5 15L12 7.5L19.5 15" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function Menu({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Menu">
      <path d="M3.75 12H20.25M3.75 6H20.25M3.75 18H20.25" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function NavigationDown({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="NavigationDown">
      <path d="M12 3.75V20.25M12 20.25L5.25 13.5M12 20.25L18.75 13.5" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function NavigationLeft({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="NavigationLeft">
      <path d="M20.25 12H3.75M3.75 12L10.5 5.25M3.75 12L10.5 18.75" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function NavigationRight({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="NavigationRight">
      <path d="M3.75 12H20.25M20.25 12L13.5 5.25M20.25 12L13.5 18.75" {...getStrokeProps(size)} />
    </Svg>
  );
}
export function NavigationUp({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="NavigationUp">
      <path d="M12 20.25V3.75M12 3.75L5.25 10.5M12 3.75L18.75 10.5" {...getStrokeProps(size)} />
    </Svg>
  );
}

export function FloppyDisk({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="FloppyDisk">
      <path
        d="M8.10156 20.25V14.25C8.10156 14.0511 8.18058 13.8603 8.32123 13.7197C8.46188 13.579 8.65265 13.5 8.85156 13.5H16.3516C16.5505 13.5 16.7412 13.579 16.8819 13.7197C17.0225 13.8603 17.1016 14.0511 17.1016 14.25V20.25M14.8516 6.75H9.60156M20.8516 7.81031V19.5C20.8516 19.6989 20.7725 19.8897 20.6319 20.0303C20.4912 20.171 20.3005 20.25 20.1016 20.25H5.10156C4.90265 20.25 4.71188 20.171 4.57123 20.0303C4.43058 19.8897 4.35156 19.6989 4.35156 19.5V4.5C4.35156 4.30109 4.43058 4.11032 4.57123 3.96967C4.71188 3.82902 4.90265 3.75 5.10156 3.75H16.7913C16.9899 3.75009 17.1804 3.82899 17.3209 3.96938L20.6322 7.28063C20.7726 7.42117 20.8515 7.61166 20.8516 7.81031Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function ShareFat({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="ShareFat">
      <path
        d="M3.09782 18.63C4.64095 16.9866 8.69188 13.5 14.4481 13.5V18L21.9481 10.5L14.4481 3V7.5C9.49813 7.5 3.1522 12.2297 2.44813 18.3319C2.43839 18.4109 2.45404 18.491 2.49284 18.5605C2.53163 18.63 2.59155 18.6854 2.66391 18.7186C2.73628 18.7518 2.81734 18.7611 2.89535 18.7452C2.97336 18.7293 3.04427 18.6889 3.09782 18.63Z"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function TextT({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="TextT">
      <path
        d="M12.8008 5.25V18.75M6.05078 8.25V5.25H19.5508V8.25M9.80078 18.75H15.8008"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}
export function TextTSlash({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="TextTSlash">
      <path
        d="M4.89844 3.75L19.8984 20.25M9.39844 18.75H15.3984M12.3984 12V18.75M12.3984 5.25V7.54031M10.3163 5.25H19.1484V8.25M5.64844 8.25V5.25H6.2625"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function Trash({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Trash">
      <path
        d="M20.25 5.25H3.75M9.75 9.75V15.75M14.25 9.75V15.75M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25"
        {...getStrokeProps(size)}
      />
    </Svg>
  );
}

export function MagicWand({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="MagicWand">
      <g>
        <path d="M20 5V3" {...getStrokeProps(size)} />
        <path d="M19 4H21" {...getStrokeProps(size)} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.87001 20.705L3.29501 19.13C2.90101 18.736 2.90101 18.098 3.29501 17.705L12.87 8.12997C13.264 7.73597 13.902 7.73597 14.295 8.12997L15.87 9.70497C16.264 10.099 16.264 10.737 15.87 11.13L6.29501 20.705C5.90201 21.098 5.26301 21.098 4.87001 20.705Z"
          {...getStrokeProps(size)}
        />
        <path d="M13.5099 13.31L10.6799 10.48" {...getStrokeProps(size)} />
        <path d="M21 15H19" {...getStrokeProps(size)} />
        <path d="M20 14V16" {...getStrokeProps(size)} />
        <path d="M9 3V5" {...getStrokeProps(size)} />
        <path d="M10 4H8" {...getStrokeProps(size)} />
      </g>
    </Svg>
  );
}

export function Alert({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Alert">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.875a8.125 8.125 0 1 0 0 16.25 8.125 8.125 0 0 0 0-16.25ZM2.125 12c0-5.454 4.421-9.875 9.875-9.875S21.875 6.546 21.875 12 17.454 21.875 12 21.875 2.125 17.454 2.125 12ZM12 6.625c.483 0 .875.392.875.875v5.25a.875.875 0 0 1-1.75 0V7.5c0-.483.392-.875.875-.875Z"
        clipRule="evenodd"
      />
      <path fill="currentColor" d="M12 17.25A1.125 1.125 0 1 0 12 15a1.125 1.125 0 0 0 0 2.25Z" />
    </Svg>
  );
}

export function CheckSquare({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CheckSquare">
      <g>
        <path
          d="M17 21C19.2 21 21 19.2 21 17V14V7C21 4.79 19.2 3 17 3H7C4.79 3 3 4.79 3 7V17C3 19.2 4.79 21 7 21H17Z"
          {...getStrokeProps(size)}
        />
        <path d="M17 7L13.8768 10L12 8.18919" {...getStrokeProps(size)} />
      </g>
    </Svg>
  );
}

export function Edit({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Edit">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9724 3.83842C15.9723 3.83834 15.9725 3.83851 15.9724 3.83842V3.83842ZM16.0608 3.92675L20.0733 7.93657L17.9989 10.0115L13.9875 6.00006L16.0608 3.92675ZM12.1401 5.37259C12.1371 5.37546 12.1342 5.37836 12.1313 5.38128C12.1284 5.38421 12.1255 5.38714 12.1226 5.3901L3.35066 14.162C3.04648 14.4665 2.8752 14.8796 2.875 15.31L2.875 19.5001C2.875 19.9311 3.0462 20.3444 3.35095 20.6492C3.6557 20.9539 4.06902 21.1251 4.5 21.1251H8.68969C9.12009 21.1249 9.53324 20.954 9.83775 20.6498L18.5822 11.9032C18.5946 11.8922 18.6068 11.8806 18.6187 11.8687C18.6307 11.8567 18.6423 11.8445 18.6534 11.832L21.3994 9.08533C21.7039 8.78061 21.8751 8.36732 21.8751 7.93653C21.8751 7.50573 21.7041 7.09257 21.3995 6.78786L17.2095 2.60057C16.9047 2.29606 16.4916 2.125 16.0608 2.125C15.63 2.125 15.2168 2.29606 14.9121 2.60057L12.1401 5.37259ZM16.7616 11.2491L12.7501 7.2375L4.625 15.3626V19.3751H8.63755L16.7616 11.2491Z"
      />
    </Svg>
  );
}

export function Copy({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Copy">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.375 3.75C7.375 3.26675 7.76675 2.875 8.25 2.875H20.25C20.7332 2.875 21.125 3.26675 21.125 3.75V15.75C21.125 16.2332 20.7332 16.625 20.25 16.625H16.625V20.25C16.625 20.7332 16.2332 21.125 15.75 21.125H3.75C3.26675 21.125 2.875 20.7332 2.875 20.25V8.25C2.875 7.76675 3.26675 7.375 3.75 7.375H7.375V3.75ZM4.625 9.125V19.375H14.875V9.125H4.625ZM16.625 14.875V8.25C16.625 7.76675 16.2332 7.375 15.75 7.375H9.125V4.625H19.375V14.875H16.625Z"
      />
    </Svg>
  );
}

export function CloudArrowDown({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="CloudArrowDown">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1676 5.50745C16.1388 5.16453 15.0433 5.07099 13.9713 5.23452C12.8993 5.39806 11.8815 5.814 11.0018 6.44806C10.1221 7.08212 9.40564 7.91616 8.9115 8.88144C8.41736 9.84671 8.15967 10.9156 8.15967 12C8.15967 12.3624 7.86585 12.6563 7.50342 12.6563C7.14098 12.6563 6.84717 12.3624 6.84717 12C6.84717 11.2105 6.96179 10.4278 7.18526 9.67604C6.77906 9.63821 6.36856 9.65456 5.96465 9.7255C5.32311 9.83817 4.71286 10.086 4.1744 10.4525C3.63594 10.819 3.18159 11.2959 2.84148 11.8514C2.50137 12.4069 2.28329 13.0284 2.2017 13.6746C2.12012 14.3209 2.1769 14.977 2.36827 15.5997C2.55964 16.2223 2.88123 16.7971 3.3117 17.2859C3.74218 17.7748 4.27168 18.1665 4.8651 18.435C5.45851 18.7036 6.10225 18.8429 6.75361 18.8437H9.0028C9.36524 18.8437 9.65905 19.1376 9.65905 19.5C9.65905 19.8624 9.36524 20.1562 9.0028 20.1562H6.75199C5.91453 20.1552 5.08686 19.9761 4.3239 19.6308C3.56094 19.2855 2.88015 18.7818 2.32668 18.1533C1.77322 17.5248 1.35975 16.7858 1.1137 15.9853C0.867645 15.1848 0.794646 14.3411 0.89954 13.5102C1.00444 12.6794 1.28483 11.8803 1.72211 11.1661C2.15939 10.4518 2.74356 9.83874 3.43587 9.36751C4.12817 8.89627 4.91277 8.57765 5.73761 8.43279C6.37997 8.31997 7.03528 8.31454 7.67705 8.41549C7.69868 8.37127 7.72073 8.32722 7.74319 8.28336C8.3321 7.13296 9.18595 6.13897 10.2344 5.38331C11.2828 4.62764 12.4958 4.13194 13.7734 3.93703C15.051 3.74213 16.3566 3.85362 17.5827 4.2623C18.8087 4.67099 19.9201 5.36517 20.8252 6.28765C21.7304 7.21012 22.4033 8.33448 22.7887 9.56807C23.174 10.8017 23.2607 12.1092 23.0416 13.3828C22.8225 14.6565 22.3038 15.8599 21.5284 16.8938C21.311 17.1837 20.8996 17.2425 20.6097 17.025C20.3197 16.8075 20.261 16.3962 20.4784 16.1063C21.1291 15.2387 21.5642 14.229 21.7481 13.1603C21.9319 12.0916 21.8592 10.9945 21.5359 9.95942C21.2125 8.92434 20.6479 7.98091 19.8884 7.20688C19.1289 6.43284 18.1964 5.85037 17.1676 5.50745ZM14.2534 11.3438C14.6159 11.3438 14.9097 11.6376 14.9097 12V17.9157L16.7894 16.036C17.0457 15.7797 17.4612 15.7797 17.7175 16.036C17.9737 16.2922 17.9737 16.7078 17.7175 16.964L14.7175 19.964C14.4612 20.2203 14.0457 20.2203 13.7894 19.964L10.7894 16.964C10.5331 16.7078 10.5331 16.2922 10.7894 16.036C11.0457 15.7797 11.4612 15.7797 11.7175 16.036L13.5972 17.9157V12C13.5972 11.6376 13.891 11.3438 14.2534 11.3438Z"
      />
    </Svg>
  );
}

export function Profile({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Profile">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.875C7.51269 3.875 3.875 7.51269 3.875 12C3.875 14.0144 4.6081 15.8577 5.82207 17.2774C6.40869 16.4665 7.15162 15.7758 8.01123 15.2481C8.32099 15.058 8.64278 14.891 8.97397 14.7478C7.99457 13.8997 7.375 12.6472 7.375 11.25C7.375 8.69568 9.44568 6.625 12 6.625C14.5543 6.625 16.625 8.69568 16.625 11.25C16.625 12.6472 16.0054 13.8997 15.026 14.7478C15.3572 14.891 15.679 15.058 15.9888 15.2481C16.8484 15.7758 17.5913 16.4665 18.1779 17.2774C19.3919 15.8577 20.125 14.0144 20.125 12C20.125 7.51269 16.4873 3.875 12 3.875ZM16.8896 18.4896C16.4195 17.784 15.8006 17.186 15.0733 16.7396C14.1865 16.1953 13.1718 15.8967 12.1331 15.8731C12.0889 15.8744 12.0445 15.875 12 15.875C11.9555 15.875 11.9111 15.8744 11.8669 15.8731C10.8282 15.8967 9.81348 16.1953 8.92669 16.7396C8.1994 17.186 7.58051 17.784 7.11045 18.4896C8.47089 19.5163 10.1644 20.125 12 20.125C13.8357 20.125 15.5291 19.5163 16.8896 18.4896ZM12.1197 14.1226C13.652 14.0598 14.875 12.7977 14.875 11.25C14.875 9.66218 13.5878 8.375 12 8.375C10.4122 8.375 9.125 9.66218 9.125 11.25C9.125 12.7977 10.348 14.0598 11.8803 14.1226C11.9202 14.1219 11.9601 14.1216 12 14.1216C12.0399 14.1216 12.0798 14.1219 12.1197 14.1226ZM2.125 12C2.125 6.54619 6.54619 2.125 12 2.125C17.4538 2.125 21.875 6.54619 21.875 12C21.875 17.4538 17.4538 21.875 12 21.875C6.54619 21.875 2.125 17.4538 2.125 12Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function MagicWandAlt({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="MagicWandAlt">
      <path
        fill="currentColor"
        d="M4.5 6a.75.75 0 0 1 .75-.75h1.5v-1.5a.75.75 0 0 1 1.5 0v1.5h1.5a.75.75 0 1 1 0 1.5h-1.5v1.5a.75.75 0 1 1-1.5 0v-1.5h-1.5A.75.75 0 0 1 4.5 6m12.75 12h-.75v-.75a.75.75 0 1 0-1.5 0V18h-.75a.75.75 0 1 0 0 1.5H15v.75a.75.75 0 1 0 1.5 0v-.75h.75a.75.75 0 1 0 0-1.5m5.25-4.5H21V12a.75.75 0 1 0-1.5 0v1.5H18a.75.75 0 1 0 0 1.5h1.5v1.5a.75.75 0 1 0 1.5 0V15h1.5a.75.75 0 1 0 0-1.5m-1.94-6L7.5 20.56a1.5 1.5 0 0 1-2.12 0l-1.941-1.938a1.5 1.5 0 0 1 0-2.122L16.5 3.44a1.5 1.5 0 0 1 2.122 0l1.938 1.938a1.5 1.5 0 0 1 0 2.122m-5.121 3L13.5 8.56l-9 9 1.939 1.94zM19.5 6.44 17.56 4.5l-3 3 1.94 1.94z"
      />
    </Svg>
  );
}

export function Book({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Book">
      <path
        fill="currentColor"
        d="M19.5 2.25H6.75a3 3 0 0 0-3 3V21a.75.75 0 0 0 .75.75H18a.75.75 0 1 0 0-1.5H5.25a1.5 1.5 0 0 1 1.5-1.5H19.5a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75m-.75 15h-12c-.527 0-1.044.138-1.5.402V5.25a1.5 1.5 0 0 1 1.5-1.5h12z"
      />
    </Svg>
  );
}

export function StackAndMinus({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="StackAndMinus">
      <path
        fill="currentColor"
        d="M21.648 11.625a.75.75 0 0 1-.273 1.023l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25a.75.75 0 0 1 .756-1.296L12 16.382l8.625-5.03a.75.75 0 0 1 1.023.273M2.25 7.5a.75.75 0 0 1 .375-.648l9-5.25a.75.75 0 0 1 .756 0l9 5.25a.75.75 0 0 1 0 1.296l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25A.75.75 0 0 1 2.25 7.5m2.239 0L12 11.882 19.511 7.5 12 3.118zM21.75 18h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5m-8.625 2.227L12 20.884l-8.625-5.032a.75.75 0 0 0-.75 1.296l9 5.25a.75.75 0 0 0 .756 0l1.5-.875a.75.75 0 1 0-.756-1.296"
      />
    </Svg>
  );
}

export function HappyFace({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="HappyFace">
      <path
        fill="currentColor"
        d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25M7.5 10.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0m9 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m-.1 4.5c-.965 1.668-2.57 2.625-4.4 2.625s-3.434-.956-4.399-2.625a.75.75 0 1 1 1.298-.75c.7 1.21 1.8 1.875 3.101 1.875s2.4-.666 3.1-1.875a.75.75 0 0 1 1.3.75"
      />
    </Svg>
  );
}

export function Stack({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Stack">
      <path
        fill="currentColor"
        d="M19.5 8.25h-15A1.5 1.5 0 0 0 3 9.75v9a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5m0 10.5h-15v-9h15zM4.5 6a.75.75 0 0 1 .75-.75h13.5a.75.75 0 1 1 0 1.5H5.25A.75.75 0 0 1 4.5 6M6 3a.75.75 0 0 1 .75-.75h10.5a.75.75 0 1 1 0 1.5H6.75A.75.75 0 0 1 6 3"
      />
    </Svg>
  );
}

export function Skates({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Skates">
      <path
        fill="currentColor"
        d="M8.8499 4.64895C7.6176 4.12869 6.0489 3.86988 3.9376 4.00185C3.6494 4.01986 3.3832 4.1615 3.2072 4.39035C3.05634 4.58651 2.98454 4.83034 3.00274 5.07427L3.0194 5.19602L4.6978 13.5882C4.90505 14.6244 5.63147 15.4461 6.5736 15.8045L6.7527 15.8662L6.2192 18H3C2.4477 18 2 18.4477 2 19C2 19.5128 2.38603 19.9355 2.88338 19.9933L3 20H17.3432C18.5808 20 19.7712 19.5411 20.6868 18.7175L20.8787 18.5355L21.7071 17.7071C22.0976 17.3166 22.0976 16.6834 21.7071 16.2929C21.3466 15.9324 20.7794 15.9047 20.3871 16.2097L20.2929 16.2929L19.4645 17.1213C18.9487 17.637 18.2646 17.9456 17.5413 17.9935L17.3432 18H16.7808L16.2659 15.9404C17.6007 15.7368 19.0267 15.0105 19.8878 13.7521C20.9901 12.1409 20.9937 9.9377 19.332 7.44517C19.152 7.17514 18.8521 7.00926 18.5277 7.00025C18.2033 6.99124 17.8947 7.14023 17.7 7.39986C17.1013 8.19805 16.6452 8.57395 16.3051 8.76184L16.1563 8.83606C15.8088 8.99053 15.5056 8.9999 15 8.9999C14.1193 8.9999 13.5913 8.74484 13.1431 8.37612C12.8404 8.12702 12.5739 7.83793 12.3177 7.53883L11.8113 6.93617C11.7267 6.83646 11.6412 6.73786 11.554 6.64148C10.9078 5.92728 10.0898 5.17247 8.8499 4.64895ZM8.7808 15.9999H14.2192L14.7192 18H8.2808L8.7808 15.9999ZM5.2137 5.96967C6.4784 5.99178 7.3869 6.20223 8.0719 6.49145C8.9414 6.85855 9.5296 7.385 10.0709 7.9833L10.3211 8.26699L10.8127 8.84288C11.1418 9.22542 11.4809 9.59837 11.8724 9.92054C12.6062 10.5244 13.5018 10.9413 14.7313 10.9942L15.0379 10.9999L15.3548 10.9973C15.8052 10.9868 16.3624 10.9331 16.9686 10.6637C17.4199 10.4631 17.863 10.1611 18.3147 9.72974C18.8902 11.0845 18.6497 12.0197 18.2371 12.6227C17.6784 13.4394 16.6203 13.9352 15.6852 13.994L15.5 13.9999H7.6396C7.20263 13.9999 6.82136 13.7171 6.68883 13.31L6.659 13.196L5.2137 5.96967Z"
      />
    </Svg>
  );
}
export function Chat({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Chat">
      <path
        fill="currentColor"
        d="M20.25 4.5H3.75A1.5 1.5 0 0 0 2.25 6v15a1.485 1.485 0 0 0 .867 1.36 1.49 1.49 0 0 0 1.594-.214l.008-.007L7.781 19.5H20.25a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5Zm0 13.5H7.5a.75.75 0 0 0-.49.183L3.75 21V6h16.5v12Z"
      />
    </Svg>
  );
}

export function Star({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Star">
      <path
        fill="currentColor"
        d="M22.4225 9.118C22.3287 8.82974 22.1517 8.57568 21.9138 8.38783C21.6759 8.19998 21.3877 8.08673 21.0856 8.06237L15.5543 7.61612L13.4187 2.45143C13.3032 2.17001 13.1066 1.92929 12.854 1.75987C12.6013 1.59046 12.304 1.5 11.9998 1.5C11.6956 1.5 11.3983 1.59046 11.1456 1.75987C10.893 1.92929 10.6964 2.17001 10.5809 2.45143L8.44714 7.61518L2.91308 8.06237C2.61043 8.08797 2.32207 8.20231 2.08412 8.39106C1.84617 8.57982 1.66921 8.8346 1.57542 9.12348C1.48163 9.41237 1.47517 9.72251 1.55686 10.015C1.63855 10.3076 1.80475 10.5695 2.03464 10.768L6.25339 14.4083L4.96808 19.8514C4.8962 20.1471 4.9138 20.4575 5.01865 20.7432C5.1235 21.0289 5.31087 21.277 5.55698 21.456C5.80309 21.635 6.09684 21.7369 6.40093 21.7486C6.70503 21.7604 7.00576 21.6815 7.26496 21.5221L11.9993 18.6083L16.7365 21.5221C16.9958 21.6796 17.2959 21.757 17.5991 21.7444C17.9022 21.7317 18.1949 21.6297 18.4401 21.451C18.6854 21.2724 18.8724 21.0252 18.9774 20.7406C19.0825 20.4559 19.101 20.1466 19.0306 19.8514L17.7406 14.4074L21.9593 10.7671C22.1911 10.5689 22.3588 10.3064 22.4413 10.0128C22.5237 9.71927 22.5172 9.40784 22.4225 9.118ZM20.9843 9.63081L16.4187 13.5683C16.3146 13.6581 16.2371 13.7747 16.1948 13.9055C16.1525 14.0362 16.1469 14.1761 16.1787 14.3099L17.5737 20.1974C17.5773 20.2055 17.5777 20.2147 17.5747 20.223C17.5717 20.2314 17.5657 20.2383 17.5578 20.2424C17.5409 20.2555 17.5362 20.2527 17.5221 20.2424L12.3921 17.0877C12.274 17.015 12.138 16.9766 11.9993 16.9766C11.8606 16.9766 11.7247 17.015 11.6065 17.0877L6.47652 20.2442C6.46246 20.2527 6.45871 20.2555 6.44089 20.2442C6.43298 20.2402 6.42692 20.2333 6.42395 20.2249C6.42099 20.2166 6.42135 20.2074 6.42496 20.1992L7.81996 14.3117C7.85175 14.178 7.84618 14.0381 7.80385 13.9073C7.76153 13.7766 7.68407 13.6599 7.57996 13.5702L3.01433 9.63268C3.00308 9.62331 2.99277 9.61487 3.00214 9.58581C3.01152 9.55675 3.01902 9.5605 3.03308 9.55862L9.02558 9.07487C9.16303 9.06308 9.29456 9.01361 9.40571 8.9319C9.51686 8.85019 9.60332 8.73941 9.65558 8.61175L11.9637 3.02331C11.9712 3.00737 11.974 2.99987 11.9965 2.99987C12.019 2.99987 12.0218 3.00737 12.0293 3.02331L14.3431 8.61175C14.3958 8.73946 14.4828 8.85012 14.5945 8.93152C14.7062 9.01291 14.8382 9.06187 14.9759 9.073L20.9684 9.55675C20.9825 9.55675 20.9909 9.55675 20.9993 9.58393C21.0078 9.61112 20.9993 9.62143 20.9843 9.63081Z"
      />
    </Svg>
  );
}

export function Rhombus({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Rhombus">
      <path
        d="M11.999 4.1377C13.1664 8.07635 16.2803 11.1781 20.2285 12.3418C16.2807 13.5054 13.1678 16.6078 12 20.5459C10.8321 16.6076 7.71862 13.5053 3.77051 12.3418C7.7189 11.1783 10.8314 8.07632 11.999 4.1377Z"
        stroke="currentColor"
      />
    </Svg>
  );
}

export function Heart({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Heart">
      <path
        d="M16.6875 3.75C14.7516 3.75 13.0566 4.5825 12 5.98969C10.9434 4.5825 9.24844 3.75 7.3125 3.75C5.77146 3.75174 4.29404 4.36468 3.20436 5.45436C2.11468 6.54404 1.50174 8.02146 1.5 9.5625C1.5 16.125 11.2303 21.4369 11.6447 21.6562C11.7539 21.715 11.876 21.7458 12 21.7458C12.124 21.7458 12.2461 21.715 12.3553 21.6562C12.7697 21.4369 22.5 16.125 22.5 9.5625C22.4983 8.02146 21.8853 6.54404 20.7956 5.45436C19.706 4.36468 18.2285 3.75174 16.6875 3.75ZM12 20.1375C10.2881 19.14 3 14.5959 3 9.5625C3.00149 8.41921 3.45632 7.32317 4.26475 6.51475C5.07317 5.70632 6.16921 5.25149 7.3125 5.25C9.13594 5.25 10.6669 6.22125 11.3062 7.78125C11.3628 7.91881 11.4589 8.03646 11.5824 8.11926C11.7059 8.20207 11.8513 8.24627 12 8.24627C12.1487 8.24627 12.2941 8.20207 12.4176 8.11926C12.5411 8.03646 12.6372 7.91881 12.6937 7.78125C13.3331 6.21844 14.8641 5.25 16.6875 5.25C17.8308 5.25149 18.9268 5.70632 19.7353 6.51475C20.5437 7.32317 20.9985 8.41921 21 9.5625C21 14.5884 13.71 19.1391 12 20.1375Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function PerCent({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} {...props} data-icon="Heart">
      <path
        d="M19.2808 5.77891L5.78084 19.2789C5.64011 19.4196 5.44924 19.4987 5.25022 19.4987C5.0512 19.4987 4.86033 19.4196 4.71959 19.2789C4.57886 19.1382 4.4998 18.9473 4.4998 18.7483C4.4998 18.5493 4.57886 18.3584 4.71959 18.2177L18.2196 4.71766C18.3602 4.57693 18.551 4.49782 18.7499 4.49773C18.9488 4.49764 19.1396 4.57659 19.2804 4.71719C19.4211 4.8578 19.5002 5.04855 19.5003 5.24749C19.5004 5.44642 19.4215 5.63724 19.2808 5.77797V5.77891ZM4.73834 9.51016C4.10543 8.87712 3.74991 8.01859 3.75 7.12342C3.75009 6.22826 4.10577 5.36979 4.73881 4.73688C5.37185 4.10397 6.23039 3.74845 7.12555 3.74854C8.02071 3.74862 8.87918 4.10431 9.51209 4.73735C10.145 5.37039 10.5005 6.22892 10.5004 7.12409C10.5004 8.01925 10.1447 8.87772 9.51163 9.51063C8.87859 10.1435 8.02005 10.4991 7.12489 10.499C6.22972 10.4989 5.37126 10.1432 4.73834 9.51016ZM5.25022 7.12516C5.25046 7.43346 5.32672 7.73694 5.47224 8.00872C5.61776 8.28051 5.82806 8.51223 6.0845 8.68334C6.34095 8.85446 6.63563 8.95971 6.94246 8.98976C7.24929 9.01981 7.55879 8.97374 7.84356 8.85562C8.12833 8.73751 8.37959 8.551 8.57508 8.31261C8.77056 8.07422 8.90425 7.7913 8.9643 7.48891C9.02436 7.18652 9.00892 6.87399 8.91936 6.57899C8.8298 6.28399 8.66887 6.01563 8.45084 5.79766C8.18851 5.53541 7.85428 5.35685 7.49044 5.2846C7.12661 5.21235 6.74951 5.24963 6.40688 5.39175C6.06424 5.53386 5.77145 5.77441 5.56556 6.08297C5.35967 6.39153 5.24993 6.75422 5.25022 7.12516ZM20.2502 16.8752C20.25 17.656 19.9791 18.4126 19.4837 19.016C18.9882 19.6195 18.2988 20.0325 17.5329 20.1847C16.7671 20.3368 15.9722 20.2188 15.2836 19.8505C14.5951 19.4823 14.0555 18.8868 13.7569 18.1653C13.4582 17.4439 13.4189 16.6412 13.6457 15.8941C13.8725 15.1469 14.3514 14.5015 15.0007 14.0678C15.65 13.6342 16.4296 13.439 17.2066 13.5157C17.9836 13.5924 18.7101 13.9361 19.2621 14.4883C19.5765 14.801 19.8257 15.173 19.9953 15.5827C20.1649 15.9924 20.2516 16.4317 20.2502 16.8752ZM18.7502 16.8752C18.7503 16.4414 18.6 16.021 18.3249 15.6856C18.0497 15.3502 17.6668 15.1206 17.2414 15.0359C16.8159 14.9511 16.3743 15.0166 15.9917 15.221C15.6091 15.4254 15.3092 15.7562 15.1431 16.1569C14.977 16.5577 14.955 17.0036 15.0809 17.4187C15.2067 17.8339 15.4726 18.1925 15.8333 18.4336C16.1939 18.6747 16.627 18.7832 17.0587 18.7408C17.4904 18.6983 17.8941 18.5075 18.2008 18.2008C18.3755 18.0271 18.514 17.8205 18.6083 17.593C18.7026 17.3655 18.7508 17.1215 18.7502 16.8752Z"
        fill="currentColor"
      />
    </Svg>
  );
}
